import type { FixedProductVariantInput } from '@vy/types';
import { PAYMENT_TERMS, FIXED_PRODUCT_TYPES } from '@vy/types';
import { useFormContext, useWatch } from 'react-hook-form';
import { useChargeContext } from '../../charge-context';
import type { NewPlanForm } from '../../CreatePlanForm/create-plan-form-types/new-plan-form';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';
import { VySwitchRow } from '@vy/ui-design-system';

export const AsCreditSelector: React.FC = () => {
  const { itemIndex: productIndex } = useChargeContext();
  const { control, setValue } = useFormContext<PlanInputForm, unknown, NewPlanForm>();

  const settingsProductTypeWatch = useWatch({
    control,
    name: `fixedProducts.${productIndex}.variants.0.settings.productType`,
  });

  const handleCreditChecked = (_event: React.SyntheticEvent, checked: boolean) => {
    if (checked) {
      setValue(`fixedProducts.${productIndex}.variants.0.settings`, getDefaultCreditProductSettings());
      setValue(`fixedProducts.${productIndex}.paymentTerm`, PAYMENT_TERMS.Prepayment);
      return;
    }

    setValue(`fixedProducts.${productIndex}.variants.0.settings`, undefined);
    setValue(`fixedProducts.${productIndex}.paymentTerm`, PAYMENT_TERMS.Postpayment);
  };

  return (
    <VySwitchRow
      title="Credit purchase"
      description="Charge the customer for credits that can be used later"
      checked={settingsProductTypeWatch === FIXED_PRODUCT_TYPES.Credit}
      onChange={handleCreditChecked}
      data-field-span="full"
      data-vy="plan-charge-drawer-credit-switch"
    />
  );
};

export const getDefaultCreditProductSettings = (): FixedProductVariantInput['settings'] => ({
  productType: FIXED_PRODUCT_TYPES.Credit,
  productConfiguration: {
    shouldCreateSeparateInvoice: false,
  },
});
